
export class TLLPopup extends google.maps.OverlayView {
    private position: any;
    private anchor: HTMLElement;

    constructor(position: google.maps.LatLng, content: HTMLElement) {
        super();
        this.position = position;

        content.classList.add("popup-bubble-content");

        const pixelOffset = document.createElement("div");
        pixelOffset.classList.add("popup-bubble-anchor");
        pixelOffset.appendChild(content);

        this.anchor = document.createElement("div");
        this.anchor.classList.add("popup-tip-anchor");
        this.anchor.appendChild(pixelOffset);

        // Optionally stop clicks, etc., from bubbling up to the map.
        this.stopEventPropagation();
    }

    public onAdd() {
        this.getPanes().floatPane.appendChild(this.anchor);
    }

    public onRemove() {
        if (this.anchor.parentElement) {
            this.anchor.parentElement.removeChild(this.anchor);
        }     
    }

    public draw() {
        const divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
        // Hide the popup when it is far out of view.
        const display =
            Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ?
                "block" :
                "none";

        if (display === "block") {
            this.anchor.style.left = divPosition.x + "px";
            this.anchor.style.top = divPosition.y + "px";
        }
        if (this.anchor.style.display !== display) {
            this.anchor.style.display = display;
        }
    }

    public stopEventPropagation() {
        const anchor = this.anchor;
        anchor.style.cursor = "auto";

        ["click", "dblclick", "contextmenu", "wheel", "mousedown", "touchstart",
            "pointerdown"]
            .forEach((event) => {
                anchor.addEventListener(event, (e) => {
                    e.stopPropagation();
                });
            });
    }

}



// WEBPACK FOOTER //
// ./src/global/TLLPopup.ts